import { Box, Typography, IconButton, Button } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import './SoftwareCard.css'

const SoftwareCard = ({ name, price, qty, onAddToCart }) => {
    return (
        <Box className="software-card">
            <Typography className="software-card-name">{name}</Typography>
            <Typography className="software-card-price">${price}</Typography>
            <Box className="software-card-controls">
                {qty >= 1 ? (
                    <IconButton size="small" className="software-card-check" disabled>
                        <CheckIcon fontSize="small" />
                    </IconButton>
                ) : (
                    <Button variant="contained" size="small" className="software-card-add-btn" onClick={onAddToCart}>
                        Add
                    </Button>
                )}
            </Box>
        </Box>
    )
}

export default SoftwareCard
